import React, { useState } from "react"
import { connect } from "react-redux"
import { Form as BootstrapForm } from "react-bootstrap"
import { Tooltip } from "@material-ui/core"
import BootstrapToggle from "react-bootstrap-toggle"
import { FormikProps } from "formik/dist/types"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons/faInfoCircle";
import {
  getAvailableMissionCodes,
  isRoutineButtonDisabled,
} from "../../../helpers/configurationHelper"
import {
  changeRoutineStatusAction,
  resetSearchAction,
  setMissionAction,
} from "../../../state/application/actions"
import {
  changeRoutineStatusActionGeomap,
  removeKMLGuideShapeAction,
  removeLastShapeAction,
  setSearchMode
} from "../../../state/geoMap/actions"
import { hasBeenFilled } from "../../../helpers/dynamicFormHelper"
import { AdvancedSearchConfigurationsType } from "../../../types/configurations"
import { ShapeType } from "../../../types/shape"
import { DEFAULT_TOOLTIP_PROPS } from "../../../helpers/tooltipHelper"
import translations from "../../../translations"
import {AppParametersType} from "../../../types/app";

interface PropsType {
  scopeConfigurationFields: string,
  configurations: AdvancedSearchConfigurationsType,
  selectedArea: ShapeType,
  disabled: boolean,
  isInterferometricStackSearch: boolean,
  removeLastShapeActionHandler: any,
  removeKMLGuideShapeActionHandler: any,
  changeRoutineStatusHandler: any,
  changeRoutineStatusHandlerGeomap: any,
  setMissionActionHandler: any,
  resetSearchActionHandler: any,
  formProps: FormikProps<any>,
  language: string,
  setSearchMode: any,
  appParameters: AppParametersType
}

const ModeField = (props: PropsType) => {
  const {
    scopeConfigurationFields,
    configurations,
    selectedArea,
    disabled,
    removeLastShapeActionHandler,
    removeKMLGuideShapeActionHandler,
    changeRoutineStatusHandler,
    changeRoutineStatusHandlerGeomap,
    setMissionActionHandler,
    resetSearchActionHandler,
    formProps,
    isInterferometricStackSearch,
    language,
    appParameters
  } = props;

  const { values, setFieldValue, resetForm } = formProps
  console.log("TEST");
  const value = values.routine
  const isInputDisabled =
    (disabled && hasBeenFilled(value)) ||
    isRoutineButtonDisabled(
      configurations,
      appParameters,
      scopeConfigurationFields,
      values,
      selectedArea
    ) // || isInterferometricStackSearch // @mapitaly la ricerca interferometrica si può fare a prescindere

  let switchElement = (
    <BootstrapToggle
      id="routine"
      name="routine"
      disabled={isInputDisabled}
      onClick={(routine) => {
        let missions: any = []
        // if there is one mission available, select it as default
        const missionCodes = getAvailableMissionCodes(configurations, {
          ...values,
          routine,
        })
        if (missionCodes.length === 1) {
          missions = missionCodes
        }
        resetSearchActionHandler()
        removeLastShapeActionHandler()
        removeKMLGuideShapeActionHandler()
        resetForm()
        setFieldValue("routine", routine)
        changeRoutineStatusHandler(routine)
        changeRoutineStatusHandlerGeomap(routine)
        setFieldValue("missions", missions)
        setMissionActionHandler(missions)
        // per resettare il search_mode che imposta la ricerca per ID
        // setFieldValue("search_mode", false)
        // setSearchMode(false)
      }}
      on={translations("routine", language)}
      onClassName="mode-switch-routine"
      // routine
      off={translations("onDemand", language)}
      offClassName="mode-switch-onDemand"
      // on-demand
      handleClassName="container-mode-switch"
      active={value}
      height="28px"
      width="147px"
    />
  )

  if (isInputDisabled) {
    switchElement = (
      <Tooltip
        {...DEFAULT_TOOLTIP_PROPS}
        title={translations("onDemNotAvaillable", language)}
        placement="top"
      >
        {switchElement}
      </Tooltip>
    )
  }

  return (
    <div className="row mx-0 mb-3">
      <BootstrapForm.Label className="col-3 m-0 px-0 d-flex">
        <Tooltip
          {...DEFAULT_TOOLTIP_PROPS}
          title={translations(values.routine ? "infoLabelSearchModeRoutine" : "infoLabelSearchModeOnDemand", appParameters.language)}
          placement="right-end"
        >
          <span className="title">
            <span style={{ textOverflow: "inherit" }}>
              *
              {translations("routineOrOnDemandLeftSearchBar", language)}
            </span>
            <FontAwesomeIcon
              icon={faInfoCircle}
              className="ml-1"
            />
          </span>
        </Tooltip>
      </BootstrapForm.Label>
      <BootstrapForm.Group className="col-9 m-0 pr-0 switch-container d-flex justify-content-end">
        {switchElement}
      </BootstrapForm.Group>
    </div>
  )
}

const mapStateToProps = (state) => ({
  configurations: state.application.configurations,
  selectedArea: state.geoMap.lastShape,
  loadingInitialData: state.application.loadingInitialData,
  isInterferometricStackSearch: state.product.isInterferometricStackSearch,
  language: state.application.appParameters.language,
  appParameters: state.application.appParameters,
})

const mapDispatchToState = (dispatch) => ({
  setMissionActionHandler: (missionCodes) => dispatch(setMissionAction(missionCodes)),
  removeLastShapeActionHandler: () => dispatch(removeLastShapeAction()),
  removeKMLGuideShapeActionHandler: () => dispatch(removeKMLGuideShapeAction()),
  changeRoutineStatusHandler: (status) => dispatch(changeRoutineStatusAction(status)),
  changeRoutineStatusHandlerGeomap: (status) => dispatch(changeRoutineStatusActionGeomap(status)),
  resetSearchActionHandler: () => dispatch(resetSearchAction()),
  setSearchMode: (search_mode) => dispatch(setSearchMode(search_mode)),

})

export default connect(mapStateToProps, mapDispatchToState)(ModeField)
